/**
 * 通知容器组件 - MVVM架构中的View层
 * 负责显示和管理通知消息
 */

import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * 通知容器组件
 * @param {Object} props - 组件属性
 * @param {Array} props.notifications - 通知列表
 * @param {Function} props.onRemove - 移除通知的回调函数
 * @returns {JSX.Element} 通知容器组件
 */
function NotificationContainer({ notifications = [], onRemove }) {
  /**
   * 自动移除通知
   * @param {string} id - 通知ID
   */
  const autoRemove = (id) => {
    setTimeout(() => {
      onRemove && onRemove(id);
    }, 5000);
  };

  useEffect(() => {
    notifications.forEach(notification => {
      if (notification.autoRemove !== false) {
        autoRemove(notification.id);
      }
    });
  }, [notifications]);

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      <AnimatePresence>
        {notifications.map((notification) => (
          <motion.div
            key={notification.id}
            initial={{ opacity: 0, x: 300 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 300 }}
            className={`
              p-4 rounded-lg shadow-lg max-w-sm
              ${notification.type === 'success' ? 'bg-green-500 text-white' : ''}
              ${notification.type === 'error' ? 'bg-red-500 text-white' : ''}
              ${notification.type === 'warning' ? 'bg-yellow-500 text-white' : ''}
              ${notification.type === 'info' ? 'bg-blue-500 text-white' : ''}
            `}
          >
            <div className="flex justify-between items-start">
              <div>
                {notification.title && (
                  <h4 className="font-semibold mb-1">{notification.title}</h4>
                )}
                <p className="text-sm">{notification.message}</p>
              </div>
              <button
                onClick={() => onRemove && onRemove(notification.id)}
                className="ml-2 text-white hover:text-gray-200"
              >
                ×
              </button>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}

export default NotificationContainer;
